import { Orientation } from '@/shared/store/app-store/types';

export const getOrientation = () =>
  window.innerWidth > window.innerHeight ? Orientation.LANDSCAPE : Orientation.PORTRAIT;
